export default __webpack_public_path__ + "static/media/home.e2b82c11.gif";